import React, { useContext, useState, useEffect } from 'react';
import { NavLink } from "react-router-dom";
import { ask__ } from './../../shared/utils/i18n.js';
import { getAppointments } from './../../shared/utils/api.js';
import { GlobalUserContext } from '../../shared/context/GlobalUserContext.js';
import { GlobalAppointmentContext } from '../../shared/context/GlobalAppointment.js';
import { GlobalIsRegisteredContext } from '../../shared/context/GlobalIsRegistered.js';
import { GlobalErrorContext } from './../../shared/context/GlobalErrorContext.js';


import './Header.scss';

export default function Header() {

  const {setGlobalError} = useContext(GlobalErrorContext);
  const {getGlobalUser} = useContext(GlobalUserContext);
  const {getGlobalAppointment, setGlobalAppointment} = useContext(GlobalAppointmentContext);
  const {getGlobalIsRegistered} = useContext(GlobalIsRegisteredContext);


  const [numberOfUpcomingVideoAppointments, setNumberOfUpcomingVideoAppointments] = useState(0);

  // user meta
  useEffect(() => {

    (async () => {

      if (getGlobalUser.isLoggedIn && getGlobalIsRegistered) {

        try {
          const reservations = await getAppointments('upcoming-video-reception');
          if (reservations.length) {
            setNumberOfUpcomingVideoAppointments(reservations.length);
          }
        } catch(err) {
          console.error(err);
          setGlobalError({
            isError: true,
            errorCode: 'PRE201'
          });
        }

      }

    })();

  }, [getGlobalAppointment]); // runs on mount and on reservation

  const displayWelcome = () => {
    return {
      __html: window.ortonWebsiteData.i18n.welcome
    };
  };

  return (
    <>
      {!window.ortonWebsiteData.env.booking.is_production ? <>
        <div className="header__env"><span>👷‍♂️👷‍♂️ Acute-kehitysympäristö 👷‍♂️👷‍♂️</span></div>
      </> : <></>}
      <div className="header">

        <div className="header__inner">

          <div className="nav">

            <h1 className="header__title">{ ask__('Title: Main title') }</h1>
            <div className="header__welcome" dangerouslySetInnerHTML={{__html: (window.ortonWebsiteData.i18n.welcome || '')}}></div>

            <ul>
              <li><NavLink activeClassName="is-active" exact={true} to="/">{ ask__('Navigation: Appointments') }</NavLink></li>
              <li><NavLink activeClassName="is-active" to="/chat">
                { ask__('Navigation: Chat') }
                {numberOfUpcomingVideoAppointments > 0 ? <>
                  <span className="header__appointment-number">{numberOfUpcomingVideoAppointments}</span>
                </> : <></>}
              </NavLink></li>
              <li><NavLink activeClassName="is-active" to="/profile">{ ask__('Navigation: My account') }</NavLink></li>
              {getGlobalUser.isLoggedIn
                ?
                  <li><NavLink activeClassName="is-active" to="/logout">{ ask__('Navigation: Logout') }</NavLink></li>
                :
                  <li><NavLink activeClassName="is-active" to="/login">{ ask__('Navigation: Login') }</NavLink></li>
                }
            </ul>

          </div>

        </div>
      </div>
    </>
  )

}
